// Единый список имён маршрутов

export enum ERouteNames {
  EQUIPMENT = 'equipment',
  EQUIPMENT_DETAIL = 'equipment-detail',
  EQUIPMENT_CREATE = 'equipment-create',
  // Системные и общие
  PAGE_NOT_FOUND = 'page-not-found', // Путь для несуществующих страниц (404)
  LOGIN = 'login', // Страница авторизации
  LOGTO_CALLBACK = 'logto-callback', // Callback авторизации Logto
  MATRIX_CALLBACK = 'matrix-callback', // Callback авторизации Matrix
  HOME = 'home', // Главная точка входа с AppLayout
  WORKSPACE = 'workspace', // Персональный рабочий стол пользователя
  USER_PROFILE = 'profile', // Страница профиля пользователя
  PORTAL_SETTINGS = 'portal-settings', // Настройки портала

  // Нежелательные события (НС)
  ADVERSE_EVENTS = 'adverse-events', // Список нежелательных событий
  ADVERSE_EVENT_DETAIL = 'detail-adverse-event', // Просмотр и редактирование НС
  CREATE_ADVERSE_EVENT = 'create-adverse-event', // Создание нового НС
  ADVERSE_GRAPH = 'adverse-graph', // Аналитические графики нежелательных событий
  ADVERSE_STATS = 'adverse-stats', // Сводная статистика нежелательных событий

  // Заявки (Тикеты)
  TICKETS = 'tickets', // Список заявок
  TICKET_DETAIL = 'ticket-detail', // Детальная страница заявки
  CREATE_TICKET = 'create-ticket', // Создание заявки
  TICKETS_GRAPH = 'tickets-graph', // Аналитические графики заявок
  TICKETS_STATS = 'ticket-stats', // Сводная статистика заявок
  TICKETS_WORK_GROUPS = 'tickets-work-groups', // Справочник групп исполнителей заявок

  // Задачи
  TASKS = 'tasks', // Реестр задач (НС / заявки / аудиты)

  // Электронные подписи
  ELECTRONIC_SIGNATURES = 'ELECTRONIC_SIGNATURES', // Реестр электронных подписей
  ELECTRONIC_SIGNATURE_CASE = 'ELECTRONIC_SIGNATURE_CASE', // Заявка электронной подписи

  // Календарь
  CALENDAR = 'calendar', // Календарь событий

  // Кадры (Staff)
  STAFF = 'staff', // Список сотрудников
  STAFF_SETTINGS = 'staff-settings', // Настройки модуля персонала
  IMPORT_DATA = 'import-data', // Универсальный мастер импорта данных
  STAFF_ACTIVITY = 'staff-activity', // Просмотр активности сотрудника

  // Предложения по улучшению (ППУ)
  IMPROVEMENTS = 'improvements', // Список предложений по улучшению
  IMPROVEMENT_DETAIL = 'improvement-detail', // Детальная карточка предложения
  IMPROVEMENTS_REGISTRY = 'improvements-registry', // Реестр ППУ
  IMPROVEMENTS_COMMISSION = 'improvements-commission', // Настройки комиссии ППУ
  IMPROVEMENTS_RATING = 'improvements-rating', // Рейтинг авторов ППУ

  // Аудиты
  AUDITS = 'audits', // Реестр аудитов
  AUDIT_CREATE = 'audit-create', // Создание аудита
  AUDIT_DETAIL = 'audit-detail', // Карточка аудита
  AUDIT_PROCESS = 'audit-process', // Процесс проведения аудита
  AUDIT_NONCONFORMITIES = 'audit-nonconformities', // Несоответствия конкретного аудита
  AUDIT_NONCONFORMITY_DETAIL = 'audit-nonconformity-detail', // Форма несоответствия аудита
  AUDITS_NONCONFORMITIES = 'audits-nonconformities', // Общий реестр несоответствий аудитов
  AUDITS_NONCONFORMITY_DETAIL = 'audits-nonconformity-detail', // Форма несоответствия в общем реестре
  AUDITS_GRAPH = 'audits-graph', // Аналитические графики аудитов
  AUDITS_ARCHIVE = 'audits-archive', // Архив проведенных аудитов
  AUDITS_CHART = 'audits-chart', // Календарный план-график аудитов
  AUDITS_GROUP = 'audits-group', // Реестр групп аудитов
  AUDIT_GROUP_DETAIL = 'audit-group-detail', // Карточка группы аудитов
  AUDIT_GROUP_CREATE = 'audit-group-create', // Создание группы аудитов

  // Обращения граждан
  CITIZEN_INQUIRIES = 'citizen-inquiries', // Реестр обращений граждан
  CITIZEN_INQUIRY_CREATE = 'citizen-inquiry-create', // Создание обращения гражданина
  CITIZEN_INQUIRIES_SETTINGS = 'citizen-inquiries-settings', // Настройки модуля обращений граждан
  CITIZEN_INQUIRY_DETAIL = 'citizen-inquiry-detail', // Детальная карточка обращения гражданина

  // Документы
  DOCUMENTS = 'documents', // Реестр документов МИС
  DOCUMENTS_FOLDER = 'documents-folder', // Документы выбранной папки

  // Наставничество (Mentorship)
  MENTORSHIP_CASES = 'mentorship-cases', // Реестр дел наставничества
  MENTORSHIP_CASE_CREATE = 'mentorship-case-create', // Создание дела наставничества
  MENTORSHIP_CASE_DETAIL = 'mentorship-case-detail', // Детальная страница дела наставничества
  MENTORSHIP_SETTINGS = 'mentorship-settings', // Настройки модуля наставничества
  MENTORSHIP_TEMPLATES = 'mentorship-templates', // Программы и шаблоны наставничества

  // Обучение (Training)
  TRAINING = 'training', // Обучение СМК

  // Актуальное и Новости
  ACTUAL = 'actual', // Раздел «Актуальное»
  NEWS = 'news', // Список новостей
  NEWS_DETAIL = 'news-detail', // Детальный просмотр новости
  NEWS_CREATE = 'news-create', // Создание новости
  NEWS_EDIT = 'news-edit', // Редактирование новости

  // Чат и Мессенджер
  CHAT_MATRIX = 'messenger', // Мессенджер Matrix

  // Уведомления
  NOTIFICATION_CENTER = 'notification-center', // Страница «Центр уведомлений»
  NOTIFICATION_SETTINGS = 'notification-settings', // Страница «Настройки уведомлений»

  // Журналы
  JOURNALS = 'journals', // Реестр журналов
  JOURNAL_DETAIL = 'journal-detail', // Детальная страница журнала

  // Аналитика и Мониторинг
  ANALYTICS = 'analytics', // Модуль аналитики
  MONITORING = 'monitoring', // Мониторинг показателей

  // Прочее
  LINKS = 'links', // Реестр полезных ссылок
  LINKS_SETTINGS = 'links-settings', // Настройки полезных ссылок
  SERVICE_WORKS = 'service-works', // Страница технических работ
}
